import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EmailOpenIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "EmailOpen",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.5 28.51h21.02c1.92 0 3.48-1.56 3.48-3.48V13.97c0-1.43-.86-2.65-2.09-3.19h-.02l-9.9-6.68c-.55-.38-1.23-.61-1.97-.61s-1.42.23-1.98.62h.01l-9.88 6.67A3.48 3.48 0 0 0 2.01 14v11.04c0 1.92 1.56 3.48 3.48 3.48h.03ZM16.59 6.67l10.01 7.01c.26.18.43.48.43.82 0 .28-.12.53-.3.72l-4.55 4.42 3.48 3.11a1.003 1.003 0 0 1-.56 1.83c-.3 0-.56-.13-.74-.33s-.87-.75-.87-.75l-6.15-5.49c-.35-.31-.82-.51-1.33-.51s-.98.19-1.33.51-1.54 1.37-1.54 1.37l-4.63 4.11-.87.75c-.18.16-.41.25-.67.25-.55 0-1-.45-1-1 0-.3.13-.56.33-.75s3.48-3.11 3.48-3.11L5.29 15.2a.99.99 0 0 1-.3-.72c0-.34.17-.64.43-.82s2.4-1.68 2.4-1.68l2.15-1.5 1.55-1.09 3.91-2.74c.16-.11.36-.18.57-.18s.41.07.58.18Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 29.29H3.29c-1.89 0-3.43-1.54-3.43-3.43V11.75c0-1.26.69-2.42 1.8-3.02l11.49-6.19c1.7-.91 3.72-.91 5.42 0l11.49 6.19c1.11.6 1.8 1.76 1.8 3.02v14.11c0 1.89-1.54 3.43-3.43 3.43M15.86 4.14c-.56 0-1.12.14-1.63.41L2.74 10.74c-.37.2-.6.59-.6 1.01v14.11c0 .63.51 1.14 1.14 1.14h25.14c.3 0 .59-.12.81-.33.22-.22.33-.5.33-.81V11.75c0-.42-.23-.81-.6-1.01L17.47 4.55c-.51-.27-1.07-.41-1.63-.41Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 20.14c-.22 0-.44-.06-.63-.19l-8.57-5.72c-.52-.35-.67-1.06-.32-1.59s1.06-.67 1.59-.32l7.94 5.29 7.94-5.29a1.146 1.146 0 1 1 1.27 1.91l-8.57 5.72c-.19.13-.41.19-.63.19Z"
      })]
    })
  }));
};
EmailOpenIcon.displayName = 'EmailOpenIcon';